import {makeStyles} from '@material-ui/core/styles'
import grey from '@material-ui/core/colors/grey'

const primarySb = grey[900]

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 8px 0 0',
  },
  toolbar: {
    ...theme.mixins.toolbar,
    display: 'flex',
    justifyContent: 'flex-start',
    marginRight: 20,
    backgroundColor: theme.palette.black90,
    '& .MuiButtonBase-root': {
      width: '100%',
      color: theme.palette.white,
      transition: 'color 0.4s',
      '&:hover': {
        color: theme.palette.sidebar.active,
      },
    },
    '& .MuiIconButton-label': {
      minWidth: 48,
    },
  },
  logoContainer: {
    textDecoration: 'none',
    '@media (min-width: 850px)': {
      display: 'flex',
    },
    color: primarySb,
    '& svg': {
      width: 75,
    },
  },
  title: {
    position: 'relative',
    fontSize: 13,
    whiteSpace: 'normal',
    display: 'flex',
    alignItems: 'center',
    lineHeight: '15px',
    '@media (min-width: 850px)': {
      paddingLeft: 30,
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 15,
        width: 1,
        height: '100%',
        background: theme.palette.customGrey.middle,
      },
    },
  },
  user: {
    '@media (max-width: 620px)': {
      position: 'absolute',
      bottom: 5,
    },
  },
  accountBlock: {
    color: theme.palette.customGrey.middle,
    fontSize: '0.875rem',
    '@media (max-width: 620px)': {
      fontSize: '0.75rem',
      marginTop: '-20px',
    },
    '& .logout': {
      marginLeft: 6,
      '@media (min-width: 621px)': {
        marginLeft: 16,
      },
      color: theme.palette.customGrey.dark,
    },
    '& .iconAccount': {
      marginLeft: 6,
      '@media (min-width: 620px)': {
        marginLeft: 14,
      },
      color: theme.palette.customGrey.dark,
    },
    '& .MuiInputBase-input': {
      padding: '0 24px 0 0',
    },
    '& .MuiFormControl-root': {
      padding: '6px 0',
      '@media (min-width: 620px)': {
        marginRight: 30,
        position: 'relative',
        '&:after': {
          content: '""',
          position: 'absolute',
          height: '100%',
          width: 2,
          top: 0,
          background: theme.palette.customGrey.light,
          right: -15,
        },
      },
      '& label + .MuiInput-formControl': {
        margin: 0,
      },
      '& .MuiInput-underline:before, & .MuiInput-underline:after ': {
        border: 'none',
      },
      '& .MuiInput-underline:hover:not(.Mui-disabled):before, & .MuiInput-underline:focus:not(.Mui-disabled):before ':
        {
          border: 'none',
        },
      '& .MuiSelect-root': {
        background: 'none',
      },
    },
  },
}))

export default useStyles
